// REDUX STORE
import appStore from 'redux/store/store'

export const appState = appStore.getState()

const CURRENT_ENVIRONMENT = "staging";

export const apiToken = "aa0f-9a36-e0e1-46fa-89c9";

export const baseUrl =
    CURRENT_ENVIRONMENT === "staging"
        ? "https://staging-api.commercey.com/"
        : "https://api.commercey.com/";

export const apiUrl = baseUrl + "admin-users/public/";
export const apiUrl_forEmail = baseUrl + "email-templates/public/";
export const apiUrl_forCategories = baseUrl + "catalog/public/";
export const apiUrl_forBrands = baseUrl + "catalog/public/";
export const apiUrl_forProducts = baseUrl + "catalog/public/";
export const apiUrl_forCoupons = baseUrl + "catalog/public/";
export const apiUrl_forCustomers = baseUrl + "customers/public";
export const apiUrl_forMultipliers = baseUrl + "catalog/public/";
export const apiUrl_forMultipliers2 = baseUrl + "settings/public/";
export const apiUrl_forProductFilters = baseUrl + "catalog/public/";
export const apiUrl_forIntegrations = baseUrl + "integrations/public/";
export const apiUrl_forVendors = baseUrl + "purchase-orders/public/";
export const apiUrl_forCart = baseUrl + "cart/public/";
export const apiUrl_forOrders = baseUrl + "orders/public/";
export const apiUrl_forPaymentIntegration = baseUrl + "catalog/public/";
export const apiUrl_forShipping = baseUrl + "settings/public/";
// export const apiUrl = "http://m4:8000/";
// export const apiUrl_forEmail = "http://m4:8001/";
export const apiUrl_forBlog = baseUrl + "blogs/public/";
// export const apiUrl_forCustomers = "http://m4:8004/";
// export const apiUrl_forCategories = "http://m4/Commercy/catalog/public/categories/";
// export const apiUrl_forBrands = "http://m4/Commercy/catalog/public/brands/";
// export const apiUrl_forProducts = "http://m4/Commercy/catalog/public/products/";
// export const apiUrl_forCoupons = "http://m4/Commercy/catalog/public/coupons/";

export const apiUrl_forProductImages = baseUrl + "images/public/products/";

export const apiUrl_forGoogleCategories = baseUrl + "settings/public/";

export const apiUrl_forImages = baseUrl + "images/public/";

export const apiUrl_forNotifications = baseUrl + "notifications/public/";
export const apiUrl_forSliders = baseUrl + "settings/public/slider";
export const apiUrl_forTestimonials = baseUrl + "settings/public/testimonial";
